export default "__VITE_ASSET__C7_as6en__"